import './HamburgerMenu.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBars } from '@fortawesome/free-solid-svg-icons'

const HamburgerMenu=({click, navBar})=>{
    return <div  className={navBar ? "hamburger__menu" : "hamburger__menu__admin"}>
                <FontAwesomeIcon icon={faBars} onClick={click}/>
            </div>
}
export default HamburgerMenu